<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>内部管理</el-breadcrumb-item>
        <el-breadcrumb-item>广州睿眼进销存</el-breadcrumb-item>
        <el-breadcrumb-item>产品目录</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <!-- 产品目录 strat -->
      <el-tab-pane name="first" label="产品目录">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入产品名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Name" label="产品名称" min-width="15%"></el-table-column>
          <el-table-column prop="Pricein" label="进货价" min-width="10%"></el-table-column>
          <el-table-column prop="Priceout" label="出货价" min-width="10%"></el-table-column>
          <el-table-column prop="Beizhuout" label="出货备注" min-width="10%"></el-table-column>
          <el-table-column prop="Priceshare" label="分润价" min-width="10%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="15%"></el-table-column>
          <el-table-column prop="Operation" min-width="9%" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickedit(scope.$index,scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>

        <!-- 编辑产品目录弹出框 start -->
        <el-dialog title="编辑产品目录" :visible.sync="editdialog" width="40%" :close-on-click-modal="false">
          <el-form :model="editForm" ref="editFormRef" label-width="140px">
            <el-form-item label="产品名称" class="addAdminForm">
              <el-input v-model="editForm.Name" placeholder="请输入产品名称"></el-input>
            </el-form-item>
            <el-form-item label="进货价" class="addAdminForm">
              <el-input v-model="editForm.Pricein" placeholder="请输入进货价"></el-input>
            </el-form-item>
            <el-form-item label="出货价" class="addAdminForm">
              <el-input v-model="editForm.Priceout" placeholder="请输入出货价"></el-input>
            </el-form-item>
            <el-form-item label="出货备注" class="addAdminForm">
              <el-input v-model="editForm.Beizhuout" placeholder="请输入出货备注"></el-input>
            </el-form-item>
            <el-form-item label="分润价" class="addAdminForm">
              <el-input v-model="editForm.Priceshare" placeholder="请输入分润价"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="funsaveedit">保存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 编辑产品目录弹出框 end -->
      </el-tab-pane>
      <!-- 产品目录 end -->

      <!-- 添加产品目录 start -->
      <el-tab-pane name="second" label="添加产品目录">
        <el-form :model="addForm" ref="addFormRef" label-width="140px">
          <el-form-item label="产品名称" class="addAdminForm">
            <el-input v-model="addForm.Name" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="进货价" class="addAdminForm">
            <el-input v-model="addForm.Pricein" placeholder="请输入进货价"></el-input>
          </el-form-item>
          <el-form-item label="出货价" class="addAdminForm">
            <el-input v-model="addForm.Priceout" placeholder="请输入出货价"></el-input>
          </el-form-item>
          <el-form-item label="出货备注" class="addAdminForm">
            <el-input v-model="addForm.Beizhuout" placeholder="请输入出货备注"></el-input>
          </el-form-item>
          <el-form-item label="分润价" class="addAdminForm">
            <el-input v-model="addForm.Priceshare" placeholder="请输入分润价"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="funsaveadd">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加产品目录 end -->

    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyNaoxjStockCatalog',
  data () {
    return {
      keywords: {
        name: ''
      },
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      addForm: {
        Name: '',
        Pricein: '',
        Priceout: '',
        Beizhuout: '',
        Priceshare: ''
      },
      editForm: {
        Id: 0,
        Name: '',
        Pricein: '',
        Priceout: '',
        Beizhuout: '',
        Priceshare: ''
      },
      editdialog: false
    }
  },
  mounted () {
    this.apiGetNaoxjStockCatalognum()
    this.apiGetNaoxjStockCataloglist()
  },
  methods: {
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetNaoxjStockCataloglist()
    },
    handleClick (tab, event) {
      this.addForm.Name = ''
      this.addForm.Pricein = ''
      this.addForm.Priceout = ''
      this.addForm.Beizhuout = ''
      this.addForm.Priceshare = ''
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetNaoxjStockCatalognum()
      this.apiGetNaoxjStockCataloglist()
    },
    funsaveadd () {
      this.apiAddNaoxjStockCatalog()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickedit (index, row) {
      this.editForm.Id = row.Id
      this.editForm.Name = row.Name
      this.editForm.Pricein = row.Pricein
      this.editForm.Priceout = row.Priceout
      this.editForm.Beizhuout = row.Beizhuout
      this.editForm.Priceshare = row.Priceshare
      this.editdialog = true
    },
    funsaveedit () {
      this.apiEditNaoxjStockCatalog()
    },
    apiAddNaoxjStockCatalog: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: this.addForm.Name,
        pricein: this.addForm.Pricein,
        priceout: this.addForm.Priceout,
        beizhuout: this.addForm.Beizhuout,
        priceshare: this.addForm.Priceshare
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddNaoxjStockCatalog, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetNaoxjStockCatalognum()
            that.apiGetNaoxjStockCataloglist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetNaoxjStockCataloglist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetNaoxjStockCataloglist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetNaoxjStockCatalognum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetNaoxjStockCatalognum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditNaoxjStockCatalog: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.editForm.Id,
        name: this.editForm.Name,
        pricein: this.editForm.Pricein,
        priceout: this.editForm.Priceout,
        beizhuout: this.editForm.Beizhuout,
        priceshare: this.editForm.Priceshare
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditNaoxjStockCatalog, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetNaoxjStockCataloglist()
          }
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.editdialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.el-tree{
  height: 350px;
  overflow-y: scroll
}
.el-tree::-webkit-scrollbar {
    display: none;
}
.select2{
    width: 100%;
}
</style>
